import styled from '@emotion/styled'

export const otpButtonsContainer = styled.div`
  margin-top: 10px;
`

export const PasscodeResentContainer = styled.div`
  margin-top: 10px;
`

export const SeparatorOrString = styled.div`
  display: flex;
  margin-top: 10px;
  justify-content: center;
  color: #a3a3a3;
`
